import { TFunction } from 'i18next'
import { useState } from 'react'

import { displayErrorToast } from '../helpers'
import { getEntityFromBlizzard } from '../api/search'
import { useQueryClient } from '@tanstack/react-query'
import useBasePath from '../hooks/useBasePath'

export const useBlizzardApi = <TBlizzardEntity>(
  type: 'character' | 'guild',
  t: TFunction,
) => {
  const basePath = useBasePath(type)
  const queryClient = useQueryClient()
  const [_1, _2, uriRegion, uriRealm, uriName] =
    window.location.pathname.split('/')

  const [blizzardInfo, setBlizzardInfo] = useState<TBlizzardEntity>()
  const [blizzardStatus, setBlizzardStatus] = useState<
    '' | 'pending' | 'not-found' | 'found'
  >('')

  const searchBlizzard = () => {
    setBlizzardStatus('pending')
    getEntityFromBlizzard(uriName, uriRealm, uriRegion, type)
      .then((response) => {
        if (response.length) {
          // This is a hacky timeout to allow the background job to retrieve character data
          // which is triggered automatically upon entity creation
          setTimeout(() => {
            setBlizzardInfo(response[0])
            queryClient.invalidateQueries({
              queryKey: [type, { path: basePath }],
            })
            setBlizzardStatus('found')
          }, 3000)
        } else {
          setBlizzardStatus('not-found')
        }
      })
      .catch((response) => {
        displayErrorToast(response, t)
        setBlizzardStatus('')
      })
  }

  return {
    uriRegion,
    uriRealm,
    uriName,
    blizzardInfo,
    blizzardStatus,
    searchBlizzard,
  }
}
